export default function PageHeader({ eyebrow, title, desc, action }) {
  return (
    <div className="fade-up mb-10 flex flex-wrap items-end justify-between gap-4">
      <div>
        <p className="eyebrow">{eyebrow}</p>
        <h1 className="mt-2 text-3xl font-extrabold tracking-tight sm:text-4xl">{title}</h1>
        {desc && <p className="mt-2 max-w-2xl text-sm leading-relaxed text-muted-foreground">{desc}</p>}
      </div>
      {action}
    </div>
  );
}
